import React from 'react';
import LayoutFullLoading from "./full-loading/full-loading";
import LayoutAppLoading from "./app-loading/app-loading";
import LoadingAppBusy from "./app-busy/app-busy";

export enum UILoadingType  {
    APP_LOADING = "app-loading",
    APP_BUSY    = "app-busy",
    FULL        = "full",
    FULL_PAGE   = "full-page"
}

// const debug = "Layout loading"
const debug = false

// temporary: track visited URLs so showAppBusyAsync's trace can show what navigation led here
/*const urlHistory: string[] = []
let isTrackingUrlHistory = false

function startTrackingUrlHistory() {
    if (isTrackingUrlHistory) {
        return
    }
    isTrackingUrlHistory = true

    const recordUrl = () => {
        urlHistory.push(window.location.href)

        if (urlHistory.length > 100) {
            urlHistory.shift()
        }
    }

    recordUrl()
    gd.router.on('route', recordUrl)
}*/

type Props = {

}

type State = {
    display     : UILoadingType | 'full' | 'app-loading' | 'app-busy' | false
    label       : string | false
    message?    : string
}

export default class LayoutLoading extends React.Component<Props, State> {

    constructor(props:Props){
        super(props);

        gd.layout.loading = this;

        // startTrackingUrlHistory()

        this.state = {
            display     : false,
            label       : false
        }

    }

    // white overlay + loading covering top & main area
    showFullLoading() {
        this.setState({
            display: UILoadingType.FULL
        })
    }

    // white overlay + loading covering top & main area
    async showAppLoadingAsync(message:string="Loading ..."): Promise<boolean> {

        return new Promise((resolve, reject) => {

            debug && console.log("loading.showAppLoading() called");

            this.setState({
                display     : 'app-loading',
                message     : message
            }, () => {
                resolve(true)
            })
        })
    }

    // white overlay + loading covering top & main area
    showAppBusyAsync(label:string='Please wait') {
        debug && console.log("loading.showAppBusyAsync() called, label=", label);

        // temporary trace
        // console.trace("!!!LayoutLoading showAppBusyAsync", label, urlHistory)

        return new Promise((resolve, reject) => {
            this.setState({
                display : UILoadingType.APP_BUSY,
                label   : label
            }, () => {

                // temporary trace
                // console.log("!!!LayoutLoading showAppBusyAsync on state change done")

                // need next tick to render loading
                // !!! it was 0 but 0 doesnt work sometimes... Vic Mac for example... so set to 25 milisec
                setTimeout(()=>{
                    // temporary trace
                    // console.log("!!!LayoutLoading showAppBusyAsync setTimeout done, resolve true")
                    resolve(true)
                }, 25);


            })

        })


    }



    // Old no async



    // this is deprecated use showAppLoadingAsync !!!
    // white overlay + loading covering top & main area
    showAppLoading(callback?:callback) {
        debug && console.log("loading.showAppLoading() called");

        this.setState({
            display: 'app-loading'
        }, () => {
            if (callback) {
                setTimeout(callback, 0);
            }
        })
    }

    // white overlay + loading covering top & main area
    showAppBusy(callback?:callback, label:string='Please wait') {
        debug && console.log("loading.showAppBusy() called, label=", label);

        // temporary trace
        // console.trace("!!!LayoutLoading showAppBusy", callback, label, urlHistory)

        this.setState({
            display: UILoadingType.APP_BUSY,
            label: label
        }, () => {
            if (callback) {
                setTimeout(callback, 0);
            }
        })
    }

    hide() {
        debug && console.log("loading.hide() called", this.state.display);

        if (!this.state.display) return;

        // temporary trace
        // console.log("!!!LayoutLoading hide")

        this.setState({
            display     : false,
            label       : false
        })
    }


    render() {
        debug && console.log("loading.render() called, display=", this.state.display);

        if (!this.state.display) return false;

        switch (this.state.display) {
            case UILoadingType.FULL:
                return <LayoutFullLoading />

            case UILoadingType.APP_LOADING:
                return <LayoutAppLoading message={this.state.message}/>
            // case 'app-loading': return <LayoutAppLoading />

            case UILoadingType.APP_BUSY:
                return <LoadingAppBusy label={this.state.label}/>
        }
    }
}
